import { toBcp47 } from '../hooks/useLocalizedFormat'
import { DEFAULT_LOCALE } from '../i18n/locales'

/**
 * Format a minor-unit amount (grosz / cents) for a given ISO currency code.
 */
export function formatMoney(minor: number, currency: string, locale?: string): string {
  const code = (currency || 'PLN').toUpperCase()
  const bcp47 = locale
    ? (locale.includes('-') ? locale : toBcp47(locale))
    : toBcp47(DEFAULT_LOCALE)
  try {
    return new Intl.NumberFormat(bcp47, {
      style: 'currency',
      currency: code,
    }).format(minor / 100)
  } catch {
    return `${(minor / 100).toFixed(2)} ${code}`
  }
}

/** Prefer amount_net_minor; fall back to legacy *_grosz aliases. */
export function planAmountNetMinor(plan: {
  amount_net_minor?: number | null
  amount_net_grosz?: number | null
}): number {
  return plan.amount_net_minor ?? plan.amount_net_grosz ?? 0
}

/** Join per-currency totals for admin/analytics summary displays. */
export function formatTotalsByCurrency(
  totals: Record<string, number> | undefined | null,
  locale?: string,
  fallbackMinor?: number,
): string {
  if (totals && Object.keys(totals).length > 0) {
    return Object.entries(totals)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([currency, amount]) => formatMoney(amount, currency, locale))
      .join(' · ')
  }
  if (fallbackMinor != null) {
    return formatMoney(fallbackMinor, 'PLN', locale)
  }
  return formatMoney(0, 'PLN', locale)
}
